import { Typography } from 'app/components/ui';
import { i18n, type MessageKey } from 'shared/i18n';
import { ResultTab } from './aiResultGrouping';
import './AiResultTabs.scss';

const TABS: { key: ResultTab; labelKey: MessageKey }[] = [
  { key: 'rad', labelKey: 'tag:ai.tab.rad' },
  { key: 'koncept', labelKey: 'tag:ai.tab.koncept' },
  { key: 'lista', labelKey: 'tag:ai.tab.lista' },
];

interface AiResultTabsProps {
  activeTab: ResultTab;
  onTabChange: (tab: ResultTab) => void;
}

export const AiResultTabs = ({ activeTab, onTabChange }: AiResultTabsProps) => (
  <div className="ai-result-tabs" role="tablist">
    {TABS.map((tab) => {
      const active = tab.key === activeTab;
      return (
        <button
          key={tab.key}
          type="button"
          role="tab"
          aria-selected={active}
          className={`ai-result-tabs__tab${active ? ' ai-result-tabs__tab--active' : ''}`}
          onClick={() => onTabChange(tab.key)}
        >
          <Typography variant="body-7" fontWeight="semibold" color={active ? '#222659' : '#84919E'}>
            {i18n(tab.labelKey)}
          </Typography>
        </button>
      );
    })}
  </div>
);
